import { WhatsappIcon, WhatsappShareButton } from "react-share";

const WhatsappShare = (props) => {
  const { shareUrl } = props;
  return (
    <WhatsappShareButton url={shareUrl ? shareUrl : ""}>
      <WhatsappIcon size={40} borderRadius={50} />
    </WhatsappShareButton>
  );
};

export default WhatsappShare;
